/**
 * EliteVault Story Blocks — lightweight fade-in on scroll.
 */
(function () {
  'use strict';

  var SELECTOR = '[data-ev-story-block]';
  var READY = 'is-revealed';
  var observer = null;

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function reveal(el) {
    if (!el) return;
    el.classList.add(READY);
  }

  function observe(el) {
    if (!el || el.classList.contains(READY)) return;
    // Theme Editor / reduced motion: show immediately (avoid invisible opacity:0 content)
    if (
      prefersReducedMotion() ||
      !('IntersectionObserver' in window) ||
      (window.Shopify && window.Shopify.designMode)
    ) {
      reveal(el);
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          reveal(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.18 });
    }
    observer.observe(el);
  }

  function initAll(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    context.querySelectorAll(SELECTOR).forEach(observe);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) initAll(event.target);
  });
})();
